import { render } from "./sideBarNav.vue?vue&type=template&id=a6a3f4d2"
import script from "./sideBarNav.vue?vue&type=script&lang=js"
export * from "./sideBarNav.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__